import { ReactElement } from 'react';

import { SendBirdProvider } from '@sendbird/uikit-react';

import { useAppSelector } from 'src/app/store/hooks';
import {
  selectCurrentMembership,
  selectSendbirdAppId,
} from 'src/features/auth/selectors';

import SendbirdConnectionManager from './SendbirdConnectionManager';
import { useConfigureSession } from './useConfigureSession';
import { useIsChatEnabled } from './useIsChatEnabled';
import { useResolveChatTokenIfEnabled } from './useResolveChatTokenIfEnabled';

export default function ChatProvider({ children }: { children: ReactElement }) {
  const currentMembership = useAppSelector(selectCurrentMembership);
  const sendbirdAppId = useAppSelector(selectSendbirdAppId);
  const membershipTokenMap = useAppSelector(
    (state) => state.chat.membershipTokenMap
  );
  const sendbirdAccessToken = useResolveChatTokenIfEnabled();
  const isChatEnabled = useIsChatEnabled();
  const configureSession = useConfigureSession();

  if (
    !sendbirdAppId ||
    !currentMembership?.id ||
    !isChatEnabled ||
    !sendbirdAccessToken ||
    !membershipTokenMap[currentMembership.id] ||
    membershipTokenMap[currentMembership.id] !== sendbirdAccessToken
  ) {
    return children;
  }

  return (
    <SendBirdProvider
      appId={sendbirdAppId.toUpperCase()}
      userId={currentMembership.id}
      configureSession={configureSession}
      accessToken={sendbirdAccessToken}
    >
      <SendbirdConnectionManager>{children}</SendbirdConnectionManager>
    </SendBirdProvider>
  );
}
